import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Box } from 'core/ui/atoms';

const WeekContainer = ({ children }) => {
  return (
    <ContainerStyle>
      {children}
    </ContainerStyle>
  );
};

WeekContainer.propTypes = {
  children: PropTypes.any.isRequired,
};

export default WeekContainer;

const ContainerStyle = styled(Box)`
  background-color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  color: ${(p) => p.theme.colors.creamWhite};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 5px;
  ${(p) => p.theme.max('md')`
    padding-top: 15px;
    padding-bottom: 15px;
    height: 48px;
  `}
`;
